import { BlogSection } from '@/types/blog';

export const finanzcoachingSection: BlogSection = {
  id: 'finanzcoaching',
  title: 'Finanzcoaching: Der Mensch als Zentrum der Entscheidung',
  content: `
    <p>Während die klassische Beratung beim Produkt ansetzt, stellt Finanzcoaching eine andere Frage: „Wer sind Sie und welche Beziehung zu Geld macht Sie wirklich handlungsfähig?"</p>
    
    <p>
      Hier arbeiten wir an der Wurzel: Ihren unbewussten Verhaltensmustern und biografischen 
      Geld-Glaubenssätzen. Die <strong>Finanzpsychologie</strong> hat nachgewiesen, dass sogenannte 
      Money Scripts (tief verankerte Überzeugungen über Geld) unsere finanziellen Entscheidungen 
      maßgeblich bestimmen – oft völlig unabhängig von unserem Fachwissen.
    </p>

    <h3>Warnsignale: Coaching vs. „Motivationsseminare"</h3>
    <p>
      In einem boomenden Markt ist die Abgrenzung zu unseriösen Anbietern entscheidend. 
      Professionelles Finanzcoaching unterscheidet sich massiv von:
    </p>

    <ul>
      <li><strong>Verdecktem Produktverkauf:</strong> Wenn unter dem Namen „Coaching" eigentlich nur der Abschluss teurer Verträge oder MLM-Systeme (Pyramidensysteme) verfolgt wird.</li>
      <li><strong>Teuren Motivationsseminaren:</strong> Hier wird oft mit psychologischem Druck gearbeitet. Ein Warnzeichen ist der „Unternehmer-Trick": Klienten werden gedrängt, als Unternehmer aufzutreten, um das gesetzliche Widerrufsrecht für Verbraucher auszuhebeln.</li>
      <li><strong>Online-Abzocke:</strong> Laut wegweisenden BGH-Urteilen (2025/2026) sind Coaching-Verträge ohne staatliche ZFU-Zulassung oft nichtig, wenn sie überwiegend aus voraufgezeichneten Inhalten ohne individuellen Live-Anteil bestehen.</li>
    </ul>

    <p>Als unabhängiger Coach verzichte ich bewusst auf formelle Verbandsmitgliedschaften. In meiner täglichen Praxis orientiere ich mich jedoch konsequent an den ethischen Standards der International Coaching Federation (ICF) – insbesondere hinsichtlich Integrität, Objektivität und der strikten Wahrung der Vertraulichkeit.</p>

    <p>Den aktuellen Ethik-Kodex finden Sie auf der <a href="https://coachingfederation.org/resource/icf-code-of-ethics/" target="_blank" rel="noopener noreferrer">offiziellen Ressourcen-Seite der ICF</a>.</p>
  `
};
